export const QUIZ_DIAGNOSTICS_RESPONSIVE_MAX_WIDTH = 999

export const QUIZ_DIAGNOSTICS_UNSUPPORTED_MAX_WIDTH = 899

export const QUIZ_DIAGNOSTICS_MIN_SUPPORTED_WIDTH =
  QUIZ_DIAGNOSTICS_UNSUPPORTED_MAX_WIDTH + 1

export const QUIZ_DIAGNOSTICS_DESKTOP_MAX_WIDTH = 1280

export const QUIZ_DIAGNOSTICS_BAR_MIN_WIDTH = 72

export const QUIZ_DIAGNOSTICS_PAGE_HORIZONTAL_PADDING = 24
